var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[(_vm.showLogoSlot)?_c('div',{class:(_vm.prefixCls + "-logo")},[_vm._t("logo")],2):_vm._e(),_vm._v(" "),_c('ul',{ref:"scrollContent",staticClass:"scroll-content-horizonal",class:(_vm.prefixCls + "-container")},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/base/menu/menu.vue?vue&type=template&id=15f97c5d&
// module id = 130
// module chunks = 0